export const getRootNavigation = (navigationPath, navigation) => {
    const rootNavigationId = navigationPath?.[0];

    if (rootNavigationId) {
        return navigation.children[rootNavigationId];
    }

    return navigation;
};
